import React from 'react';
import { toast } from 'react-hot-toast';
import { AlertCircle, CheckCircle, Info } from 'lucide-react';

interface ToastOptions {
  title?: string;
  description?: string;
  duration?: number;
}

export const showToast = {
  success: ({ title = 'Success', description, duration = 4000 }: ToastOptions) => {
    toast.custom(
      t => (
        <div
          className={`${
            t.visible ? 'animate-enter' : 'animate-leave'
          } max-w-md w-full bg-dark-card shadow-lg rounded-lg pointer-events-auto flex ring-1 ring-black ring-opacity-5`}
        >
          <div className="flex-1 w-0 p-4">
            <div className="flex items-start">
              <div className="flex-shrink-0 pt-0.5">
                <CheckCircle className="h-5 w-5 text-green-400" />
              </div>
              <div className="ml-3 flex-1">
                <p className="text-sm font-medium text-dark-text">{title}</p>
                {description && <p className="mt-1 text-sm text-dark-muted">{description}</p>}
              </div>
            </div>
          </div>
        </div>
      ),
      { duration }
    );
  },

  error: ({ title = 'Error', description, duration = 5000 }: ToastOptions) => {
    toast.custom(
      t => (
        <div
          className={`${
            t.visible ? 'animate-enter' : 'animate-leave'
          } max-w-md w-full bg-dark-card shadow-lg rounded-lg pointer-events-auto flex ring-1 ring-black ring-opacity-5`}
        >
          <div className="flex-1 w-0 p-4">
            <div className="flex items-start">
              <div className="flex-shrink-0 pt-0.5">
                <AlertCircle className="h-5 w-5 text-red-400" />
              </div>
              <div className="ml-3 flex-1">
                <p className="text-sm font-medium text-dark-text">{title}</p>
                {description && <p className="mt-1 text-sm text-dark-muted">{description}</p>}
              </div>
            </div>
          </div>
        </div>
      ),
      { duration }
    );
  },

  info: ({ title = 'Info', description, duration = 4000 }: ToastOptions) => {
    toast.custom(
      t => (
        <div
          className={`${
            t.visible ? 'animate-enter' : 'animate-leave'
          } max-w-md w-full bg-dark-card shadow-lg rounded-lg pointer-events-auto flex ring-1 ring-black ring-opacity-5`}
        >
          <div className="flex-1 w-0 p-4">
            <div className="flex items-start">
              <div className="flex-shrink-0 pt-0.5">
                <Info className="h-5 w-5 text-primary-400" />
              </div>
              <div className="ml-3 flex-1">
                <p className="text-sm font-medium text-dark-text">{title}</p>
                {description && <p className="mt-1 text-sm text-dark-muted">{description}</p>}
              </div>
            </div>
          </div>
        </div>
      ),
      { duration }
    );
  },
};
